export class SitemapMessages {
  public accessibility = 'sitemap.accessibility';
  public commitmentQuality = 'sitemap.commitment-quality';
  public contact = 'sitemap.contact';
  public avisPub = 'sitemap.avisPub';
  public home = 'sitemap.home';
  public knowUs = 'sitemap.know-us';
  public legalsNotices = 'sitemap.legals-notices';
  public ourEngagement = 'sitemap.our-engagements';
  public personalData = 'sitemap.personal-data';
  public sitemap = 'sitemap.sitemap';

  constructor() {
  }
}
